<div class="container-fluid p-0">
    <nav>
        <ul class="nav nav-tabs">
            <li class="nav-item pe-1">
                <a class="nav-link" jhiTranslate="audit.germplasm-basic-details.nav.basic-details"
                   [routerLink]="['basic-details']" [routerLinkActive]="['active']" queryParamsHandling="merge">Basic details</a>
            </li>
            <li class="nav-item pe-1">
                <a class="nav-link" jhiTranslate="audit.germplasm-basic-details.nav.reference"
                   [routerLink]="['reference']" [routerLinkActive]="['active']" queryParamsHandling="merge">Reference</a>
            </li>
        </ul>
    </nav>
    <div class="tab-content p-3">
        <router-outlet></router-outlet>
    </div>
</div>

